import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
//import leanClound from '@/components/push' //引入Leancloud
import communityManagement from 'page/communityManagement/_res' //社区管理
// import deviceManagement from 'page/deviceManagement/_res' //设备管理
import systemManagement from 'page/systemManagement/_res' //用户管理
import enterpriseManagement from 'page/enterpriseManagement/_res' // 企业管理
import operateManagement from 'page/operateManagement/_res' // 运营管理
import messageManagement from 'page/messageManagement/_res' // 消息头部
import personalSet from '@/container/views/personalSet/_res' // 个人信息
import asideMessageManagement from 'page/asideMessageMangement/_res' // 消息管理（侧边）
import witLift from 'page/witLift/_res' // 智能电梯（侧边）
import intelligentDevice from 'page/intelligentDevice/_res.js' // 智能设备（侧边）
import tradeArea from 'page/tradeAreaMangement/_res' // 智能电梯（侧边）
import operation from 'page/operation/_res' // 智能终端管理
import technicalSupport from 'page/technicalSupport/_res.js' // 技术支持
import iot from 'page/iot/_res.js' //物联应用
Vue.use(Router)

const router = new Router({
    routes: [{
        path: '/',
        redirect: '/login'
    },
    { path: '/login', name: 'login', component: (resolve) => require(["@/container/views/login"], resolve) },
    { path: '/404', name: 'error', component: (resolve) => require(["@/container/views/err"], resolve) }
    ]
});
const authRouterMap = [{
    name: '首页',
    path: '/home',
    redirect: '/home/projectManagement',
    component: (resolve) => require(["@/container/views/content"], resolve),
    meta: {},
    children: [
        ...intelligentDevice,
        ...communityManagement,
        ...systemManagement,
        ...enterpriseManagement,
        ...operateManagement,
        ...messageManagement,
        ...personalSet,
        ...asideMessageManagement,
        ...witLift,
        ...tradeArea,
        ...operation,
        ...technicalSupport,
        ...iot
    ]
},
{ path: '*', redirect: '/404', hidden: true }
];

let isFirstInto = true;

let userFilterRouter = function (authRouterMap, userConfig) {

    let a = authRouterMap[0].children.filter(item => {
        if (item.meta.show) {
            if (userConfig[item.meta.show] === '1') { //判断当前是否有权限
                if (item.children) {
                    let b = item.children.filter(o => {
                        if (userConfig[o.meta.show] === '1') { //判断当前子集是否有权限
                            return true;
                        }
                        return false;
                    })
                    item.children = b;
                }
                return true
            } else {
                return false
            }
        } else { //判断是否有meta 属性
            return false
        }
    })

    authRouterMap[0].children = a;
    return authRouterMap;
}

let isLogin = function () {
    return localStorage.getItem('userInfo');
};

const resetRouteByPermission = (params, callback) => {
    let key = false;
    const arr = store.getters.asideData;
    const permission = store.getters.permission;

    return key;
};
router.beforeEach(async (to, from, next) => {
    // console.log(router.history)
    // 不在对应页面时，取消缓存
    // if(to.name=='deviceManagementList'){
    //     to.meta.keepAlive=true;
    // }
    // if(from.name=="firmwareUpdate"&&to.name!="deviceHistory"){
    //     from.meta.keepAlive=false;
    // }
    // if(to.name=="allocationFunction" || to.name=="projectManagement-house" || to.name=="contact-company"){
    //     from.meta.keepAlive=true;
    // }else{
    //     if(from.name=="projectManagement"){
    //         from.meta.keepAlive=false;
    //     }
    // }
    if (to.path === '/login') {
        let changePasswordTip = localStorage.getItem("changePasswordTip");
        localStorage.clear();
        if (changePasswordTip) {
            localStorage.setItem("changePasswordTip", changePasswordTip)
        };
        isFirstInto = true;
    }
    if (!isLogin && to.path !== '/login') { //本地未登陆 且 非登陆页
        return next('/login')
    } else if (isFirstInto && to.path !== '/login') {
        isFirstInto = false;
        //判断有无权限对象
        if (!store.getters.permission) {
            //获取权限
            await store.dispatch('updatedPermission');
        }
        if (store.getters.pushId) {

        }

        setTimeout(() => {
            //console.log(store.getters.permission);
            let userPerms = { '1100': '1', '1110': '1', '1130': '1' }; // 模拟后台返回数据
            let accessedRouters = userFilterRouter(authRouterMap, userPerms);
            router.addRoutes(accessedRouters);
        }, 500)

        //自动跳转到第一个有权限的页面作为首页
        let key = false;
        const arr = store.getters.asideData;
        const permission = store.getters.permission;
        let navId = null;
        arr.forEach(val => {
            if (val.link === to.path) {
                navId = val.id;
                key = val.auth || (val.show.split(',').filter(it => permission[it]).length > 0 &&
                    (!val.minorPem || val.minorPem.split(',').filter(it => permission[it]).length > 0));
            } else if (val.menuItem) {
                val.menuItem.forEach(value => {
                    let pathItem = to.path.split('/');
                    const _path = `/${pathItem[1]}/${pathItem[2]}`;
                    if (value.link === _path) {
                        navId = val.id;
                        key = value.auth || (value.show.split(',').filter(it => permission[it]).length > 0 &&
                            (!value.minorPem || value.minorPem.split(',').filter(it => permission[it]).length > 0));
                    }
                });
            }
        });
        if (!key) {
            for (let i = 0; i < arr.length; i++) {
                let _key = arr[i].show.split(',').filter(it => permission[it]).length > 0 &&
                    (!arr[i].minorPem || arr[i].minorPem.split(',').filter(it => permission[it]).length > 0);
                if (_key) {
                    navId = arr[i].id;
                    return next(arr[i].link)
                } else if (arr[i].menuItem) {
                    for (let j = 0; j < arr[i].menuItem.length; j++) {
                        const value = arr[i].menuItem[j];
                        _key = value.show.split(',').filter(it => permission[it]).length > 0 &&
                            (!value.minorPem || value.minorPem.split(',').filter(it => permission[it]).length > 0);
                        if (_key) {
                            navId = arr[i].id;
                            return next(value.link)
                        }
                    }
                }
            }
        }
        localStorage.setItem("navId", navId)
    }
    next();
})


//页面重新发布后页面若不刷新会报错，处理
router.onError((error) => {
    console.log("error1", "%O", error);
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    console.log("targetPath", targetPath, router.history)
    if (isChunkLoadFailed) {
        console.log("error2", error);
        router.replace(targetPath);
    }
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js